export var __useDefault = true; export default "<img class=\"flicon-logo-fullcolor\" src=\"<%- cdn_url('/build/icons/fl-logo.svg') %>\">\n";